var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 5.958.67.112A4.002 4.002 0 0 1 16 10.015v6.828l.172.172H7.828L8 16.843v-6.828c0-1.98 1.44-3.628 3.33-3.945l.67-.112zm1-1.86V3.015a1 1 0 1 0-2 0v1.083a6.002 6.002 0 0 0-5 5.917v6l-1.293 1.292c-.63.63-.184 1.707.707 1.708h13.172c.89 0 1.337-1.078.707-1.708L18 16.015v-6a6.002 6.002 0 0 0-5-5.917zM12 22a2 2 0 0 0 2-2h-4a2 2 0 0 0 2 2z"
  })));
};
export default SvgBell;